import React, { useEffect, useContext, useState } from 'react';
import { isEmpty } from 'lodash';

import {
    Grid,
} from '@material-ui/core';

import {
    PageHeader,
    PageLoader,
    ErrorView
} from '../../common';

import {
    BuildStatus,
    BuildsList,
    BuildAppDialog
} from './components';

import { PageProvider, PageContext } from './PageContext';
import { ToastContext } from '../../contexts';

import { LicenseStatus, Aphorisms, ProcessStatus } from '../../../helpers';

import { RoutePaths, navigateTo } from '../../routing';

import { useTranslation } from "react-i18next";

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {},
    progress: {
        color: "black"
    }
}));

const PageContent = (props) => {
    const classes = useStyles();

    const { t } = useTranslation();

    const {
        state,
        pageIsReady,
        pageHasError,
        setPageIsReady,
        isBusy,
        setIsBusy,
        checkLicenseAsync,
        getSettingsAsync,
        getAppConfigAsync,
        getBuildsAsync,
        createBuildAsync,
    } = useContext(PageContext);

    const {
        showSuccessMessage,
        showErrorMessage
    } = useContext(ToastContext);

    const {
        license,
        settings,
        appConfig,
        builds,
        isLegacy
    } = state;

    const [aphorism, setAphorism] = useState(Aphorisms[Math.floor(Math.random() * Aphorisms.length)])

    const enqueueBuildClickHandler = async (e) => {
        setIsBusy({ enqueuing: true });
        const buildStatus = await createBuildAsync();
        if (buildStatus !== null) {
            await getBuildsAsync();
            showSuccessMessage(buildStatus.message);
        }
        setIsBusy({ enqueuing: false });
    }

    const refreshListClickHandler = async (e) => {
        setIsBusy({ reload: true });
        await getBuildsAsync();
        setIsBusy({ reload: false });
    }

    const actionHandler = async (action, build, bundle) => {
        switch (action) {

            case "download":
                setIsBusy({ download: true });
                const href = bundle.downloadUrl;
                var anchor = document.createElement('a');
                anchor.href = href;
                anchor.download = href;
                document.body.appendChild(anchor);
                anchor.click();
                setIsBusy({ download: false });
                break;
        }
    }

    const pageReadyDeps = [license, settings, appConfig, builds];
    useEffect(() => {
        setPageIsReady([
            () => checkLicenseAsync(),
            () => getSettingsAsync(),
            () => getAppConfigAsync(),
            () => getBuildsAsync()
        ], pageReadyDeps);
    }, pageReadyDeps);

    useEffect(() => {
        if (isLegacy) {
            navigateTo(RoutePaths.Migrate);
        }
    }, [isLegacy]);

    useEffect(() => {
        if (builds && builds.length > 0) {
            const timeoutIds = [];
            builds.forEach(build => {
                if (build.status == ProcessStatus.Enqueued
                    || build.status == ProcessStatus.Processing) {
                    const intervalId = setTimeout(async () => {
                        await getBuildsAsync();
                    }, 180 * 1000);
                    timeoutIds.push(intervalId);
                }
            });
            return () => {
                timeoutIds.forEach(id => {
                    console.debug(`Clearing timeout with id ${id}`);
                    clearTimeout(id);
                });
            }
        }
    }, [builds]);

    return (
        <>
            {pageIsReady ?
                pageHasError ?
                    <ErrorView />
                    :
                    <Grid container spacing={3} className={classes.root}>
                        <Grid item xs={12}>
                            <PageHeader
                                action1
                                action2
                                title={t("LabelBuilds")}
                                subtitle={t("LabelDownloadYourBuilds")}
                                action1ButtonText={t("ButtonCreateBuild")}
                                action2ButtonText={t("ButtonRefresh")}
                                onAction1Click={enqueueBuildClickHandler}
                                onAction2Click={refreshListClickHandler}
                                action1Disabled={license.status !== LicenseStatus.Active
                                    || (!settings.enableiOSBuild && !settings.enableAndroidBuild)
                                    || isEmpty(appConfig)
                                }
                                disabled={isBusy()}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <BuildStatus />
                            <BuildsList
                                itemsPerPage={10}
                                onAction={actionHandler}
                                loading={isBusy()}
                            />
                            <br />
                        </Grid>
                    </Grid>
                :
                <PageLoader aphorism={aphorism} enableAphorism />
            }
        </>
    );
}

export const BuildsPage = () => {

    return (
        < PageProvider >
            <PageContent />
        </PageProvider >
    );
}